// URLs
export const CALENDLY_URL = "https://calendly.com/your-calendly-link";

// Routes
export const ROUTES = {
  HOME: "/",
  PRODUCT: "/product",
  SOLUTIONS: "/solutions",
  ENTERPRISE: "/enterprise",
  PRICING: "/pricing",
  RESOURCES: "/resources",
  CONTACT_SALES: "/contact-sales",
  START_POC: "/start-poc"
}; 